import React, { useRef, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@material-ui/core";
import NewNewsletter from "./NewNewsletter.js";
import SendToAll from "./SendToAll.js";
import SendToSpecific from "./SendToSpecific.js";
import API from "../../actions";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

export default props => {
    const classes = useStyles();
    const newsletterDialogRef = useRef();
    const [newsletters, setNewsletters] = useState([]);

    const getNewsletter = async () => setNewsletters(await API.getNewslettersFromTherapist());

    useEffect(() => {
        getNewsletter();
    }, []);

    return (
        <div style={{ margin: "30px 0 20px 0" }}>
            <NewNewsletter new={true} update={getNewsletter} />
            <Typography variant="h4" gutterBottom>
                Nyhedsbrev skabeloner
            </Typography>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Emnefelt</TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {newsletters.map(row => (
                            <TableRow key={row.subject}>
                                <TableCell component="th" scope="row">
                                    {row.subject}
                                </TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right">
                                    <NewNewsletter new={false} ref={newsletterDialogRef} update={getNewsletter} />
                                    <SendToSpecific name={row.subject} description={row.message} />
                                    <SendToAll newsletter={true} name={row.subject} description={row.message} />
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            newsletterDialogRef.current.editNewsletter(
                                                row.id,
                                                row.subject || "",
                                                row.message || ""
                                            )
                                        }>
                                        Rediger
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};
